import { render, staticRenderFns } from "./right-topic.vue?vue&type=template&id=b39e2946&scoped=true&"
import script from "./right-topic.vue?vue&type=script&lang=js&"
export * from "./right-topic.vue?vue&type=script&lang=js&"
import style0 from "./right-topic.vue?vue&type=style&index=0&id=b39e2946&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39e2946",
  null
  
)

export default component.exports